import { Send } from "lucide-react";
import { Reveal } from "./Reveal";
import { XIcon } from "./OfficialLinks";
import { TELEGRAM_URL, X_URL } from "@/config";
import { scrollToId } from "@/lib/scroll";
import { useLanguage } from "@/i18n/LanguageContext";

export const Community = () => {
  const { t } = useLanguage();
  return (
  <section id="community" className="relative overflow-hidden px-5 py-28 sm:px-8 sm:py-36">
    <div className="hero-glow pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full" />
    <img
      src="/mascots/solmoo-banner.webp"
      alt=""
      className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-30"
    />
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#08080F] via-[#08080F]/55 to-[#08080F]" />

    <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center text-center">

      <Reveal delay={0.1}>
        <h2 className="font-display mt-10 text-5xl font-extrabold leading-[1.02] tracking-tight sm:text-7xl lg:text-8xl">
          <span className="text-flow">
            {t("community.heading")}
          </span>{" "}
          <span className="text-[#F5F3FF]">🐮🌕</span>
        </h2>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="mt-6 max-w-xl text-base text-gray-300 sm:text-lg">
          {t("community.sub")}
        </p>
      </Reveal>

      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            data-testid="community-join-telegram-btn"
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-solana-gradient inline-flex items-center gap-2.5 rounded-full px-9 py-4 text-base font-bold text-white shadow-[0_0_40px_rgba(153,69,255,0.5)] transition-transform hover:scale-105 sm:text-lg"
          >
            <Send size={19} />
            {t("community.telegram")}
          </a>
          <button
            data-testid="community-buy-solmoo-btn"
            onClick={() => scrollToId("how-to-buy")}
            className="inline-flex items-center gap-2.5 rounded-full border-2 border-[#14F195]/50 bg-[#0E0E16] px-9 py-4 text-base font-bold text-[#14F195] transition-colors hover:bg-[#14141E] sm:text-lg"
          >
            {t("community.buy")}
          </button>
          <a
            data-testid="community-x-btn"
            href={X_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="SOLMOO on X"
            className="inline-flex h-[58px] w-[58px] items-center justify-center rounded-full border-2 border-purple-500/50 bg-[#0E0E16] text-purple-100 transition-colors hover:border-[#14F195]/60 hover:text-[#14F195]"
          >
            <XIcon size={20} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
